import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-white px-4 py-4" data-id="element-163" data-mp="3kqw3yjl330fl">
      <div className="mx-auto max-w-3xl" data-id="element-164" data-mp="3fze4jzypl7wq">
        <h2 className="mb-2.5 text-center font-display text-[21px] leading-tight text-ev-black sm:text-3xl" data-id="element-165" data-mp="3fyco1fyxbt7m">
          What Technicians Are Saying
        </h2>
        <ul className="grid grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-166" data-mp="36yplgqugkhcz">
          {testimonials.map((testimonial, index) => <li key={testimonial.name} className={`flex flex-col rounded-lg border border-ev-line bg-ev-paper p-3 ${index === 0 ? 'sm:col-span-2' : ''}`} data-id="element-167" data-mp="31yuxav22i5vm" data-mpi={index}>
              <div className="mb-1 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-168" data-mp="2s3jh08b0gqlr">
                {Array.from({
              length: 5
            }).map((_, star) => <StarIcon key={star} aria-hidden="true" className="h-3.5 w-3.5 fill-[#F5A623] text-[#F5A623]" data-id="element-169" data-mp="qall23lxthwl" data-mpi={star} />)}
              </div>
              <p className="text-[13px] font-medium leading-snug text-ev-black/80 sm:text-[14px]" data-id="element-170" data-mp="m62n7z61vxr7">
                “{testimonial.quote}”
              </p>
              <div className="mt-auto pt-2" data-id="element-171" data-mp="c6vdrn2fsn9d">
                <p className="font-cond text-[16px] tracking-wide text-ev-black" data-id="element-172" data-mp="c7wrjzau7nus">
                  {testimonial.name}
                </p>
                <p className="text-[11px] font-semibold uppercase tracking-wide text-ev-black/55" data-id="element-173" data-mp="zyiujc5zihxx">
                  {testimonial.role} • {testimonial.location}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}